module.exports = __webpack_public_path__ + "img/bronze.3844b462.png";